import { ControlFacet } from '../models/controls/ControlFacet';

/**
 * Control which allows augmentation of the children of item sets.
 *
 * If a UX component or addon needs to create a 'projection' of the children of a specific item,
 * it may inject a handler for this control so that the list components within Items View
 * display the projection of the item set rather than the version directly from the cache.
 */
export const childItemsControl = new ControlFacet<{
    /**
     * The key for an item set.
     */
    itemKey: string | undefined;
}, {
        /**
         * The default child item keys extracted from the childItemsFacet.
         */
        itemKeys: string[] | undefined;
    }>('childItemsControl');
